define("shared/components/shared/social/refresh-profile/base-button", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! Note: Base button component for various social profile refresh buttons }}
  {{#if @onProfileRefresh.isRunning}}
    {{! Note: Disabled button used only to show refreshing state }}
    <Shared::Ui::Button
      @class={{if (eq @buttonVariant "actionLink") "u--text--black"}}
      @isDisabled={{true}}
      @text={{t "shared_words.refreshing"}}
      @variant={{if (eq @buttonVariant "actionLink") "actionLink" "outline"}}
    />
  {{else}}
    <Shared::Ui::Button
      @isDisabled={{@isLocked}}
      @onClick={{perform @onProfileRefresh}}
      @text={{t "shared_words.refresh"}}
      @variant={{if @buttonVariant @buttonVariant "actionLink"}}
      data-social-profile-refresh-id="profile-refresh-button"
      title={{@socialProfile.errorText}}
      ...attributes
    />
  {{/if}}
  */
  {
    "id": "GSdzqbMV",
    "block": "[[[41,[30,1,[\"isRunning\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@class\",\"@isDisabled\",\"@text\",\"@variant\"],[[52,[28,[37,2],[[30,2],\"actionLink\"],null],\"u--text--black\"],true,[28,[37,3],[\"shared_words.refreshing\"],null],[52,[28,[37,2],[[30,2],\"actionLink\"],null],\"actionLink\",\"outline\"]]],null],[1,\"\\n\"]],[]],[[[1,\"  \"],[8,[39,1],[[24,\"data-social-profile-refresh-id\",\"profile-refresh-button\"],[16,\"title\",[30,3,[\"errorText\"]]],[17,4]],[[\"@isDisabled\",\"@onClick\",\"@text\",\"@variant\"],[[30,5],[28,[37,4],[[30,1]],null],[28,[37,3],[\"shared_words.refresh\"],null],[52,[30,2],[30,2],\"actionLink\"]]],null],[1,\"\\n\"]],[]]]],[\"@onProfileRefresh\",\"@buttonVariant\",\"@socialProfile\",\"&attrs\",\"@isLocked\"],false,[\"if\",\"shared/ui/button\",\"eq\",\"t\",\"perform\"]]",
    "moduleName": "shared/components/shared/social/refresh-profile/base-button.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});